export namespace CommonConstants {
  export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

  export const FooterText = '© 2021-22 All rights reserved.';

  export const panelFileSizeLimit = 1048576;
  export const panelFileSizeErrorMsg = 'File Size should be less than 1MB';

  export const panelDocumentSizeLimit = 5242880;
  export const panelDocumentSizeErrorMsg = 'File Size should be less than 5MB';

  export const recaptchaKey: string =
    '6LfWTOsUAAAAABDofal4vJWsf_8S3TDU3lF8zf2U';
  export const successMessage: string = 'Success!';
  export const errorMessage: string = 'Server Error!';
  export const errorCodeCredentials: number = 400;
  export const delayTime: number = 500;
  export const fileSizeLimit: number = 5000000;
  export const fileSizeLimitMessage =
    'File size should not be greater than 5 MB';
  export const roleAccessMessage = 'You dont have permissions to access this';
  export const urlRegex: string =
    '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  export const multipleMobileRegex: string =
    '^(\+?\d{1,3}?\d{10})(,(\+?\d{1,3}?\d{10}))*$';

  export const passphrase = 'IC';
  export const authorizationKey = 'icAdminToken';
  export enum SortDirection {
    None = 0,
    Asc = 1,
    Desc = 2,
  }

  export enum FilterOperator {
    NOFILTER = 1,
    EQUALTO,
    NOTEQUALTO,
    GREATERTHAN,
    LESSTHAN,
    CONTAINS,
    STARTSWITH,
    ENDSWITH,
    BETWEEN,
  }

  export enum EntityMode {
    View = -1,
    Add = 0,
    Edit = 1,
  }
  export enum ActiveStatus {
    InActive = 0,
    Active = 1,
  }
  export enum Role {
    Administrator = 1,
    Restaurant = 2,
    Outlet = 3,
    Manager = 4,
    Customer = 5,
  }
  export enum DiscountType {
    Percentage = 1,
    FreeItem = 2,
    Fixed = 3,
  }
  export enum RequestStatus {
    Accept = 0,
  }
  export enum DeliveryType {
    Delivery = 1,
    Pickup = 2,
    Both = 3,
    Table = 4,
    Kiosk = 5,
  }
  export enum MenuLevel {
    Addon = 0,
    MenuItem = 1,
    SubCategory = 2,
    Category = 3,
  }
  export enum AddonSelectionType {
    Radio = 1,
    CheckBox = 2,
  }
  export enum OrderType {
    Now = 1,
    Later = 2,
  }
  export enum RateType {
    Percentage = 1,
    Fixed = 2,
  }
  export enum FeeCalculationType {
    BeforeDiscount = 1,
    AfterDiscount = 2,
    NetAmount = 3,
  }
  export enum TransactionType {
    Credit = 1,
    Debit = 2,
  }
  export enum PaymentType {
    Cash = 1,
    Credit = 2,
  }
  export enum PasswordResetType {
    VerificationLink = 1,
    VerificationCode = 2,
    ResetPassword = 3,
  }
  export enum PaymentStatus {
    Initiated = 1,
    Failed = 2,
    Pending = 3,
    Accept = 4,
    FullRefund = 5,
    PartialRefund = 6,
  }
  export enum PaymentMode {
    CashPayment = 1,
    Paypal = 2,
    SquareUp = 3,
    CardConnect = 4,
    Authorize = 5,
    AuthorizeV2 = 6,
    NMI = 7,
    PaymentHub = 8,
  }
  export enum OrderStatus {
    Processing = 0,
    Confirmed = 1,
    Rejected = 2,
    FullRefund = 3,
    PartialRefund = 4,
    Delivered = 5,
  }
  export enum OrderSource {
    Android = 1,
    Web = 2,
    Ios = 3,
    Kiosk = 4,
    Chat = 5,
    Voice = 6,
  }
  export enum DeviceType {
    Android = 1,
    Ios = 3,
  }
  export enum TableType {
    QrCode = 1,
    Kiosk = 2,
  }
  export enum Country {
    India = 108,
    Usa = 238,
  }
  export enum ReceiptType {
    Email = 1,
    Sms = 2,
  }
  export enum OtpType {
    Email = 1,
    Mobile = 2,
    Both = 3,
  }
  export enum RiderType {
    InHouse = 0,
    Shipday = 1,
    Doordash = 2,
  }
  export enum RiderProcessType {
    None = 0,
    Auto = 1,
    Manual = 2,
  }
  export enum UndeliverableType {
    Dispose = 0,
    Return = 1,
  }
  export enum RiderTipType {
    NoTip = 0,
    Full = 1,
    Percentage = 2,
    Fixed = 3,
  }
  export enum DistanceUnitType {
    Km = 1,
    Miles = 2,
  }
  export enum DeviceNotificationType {
    All = 0,
    Android = 1,
    IOS = 3,
  }
  export enum GiftCardType {
    Ecard = 1,
    Physical = 2,
  }
  export enum BuyType {
    Self = 1,
    Gift = 2,
  }
  export enum ProductDeliveryMode {
    Email = 1,
    Sms = 2,
    Both = 3,
  }
  export enum DeviceUserType {
    Merchant = 1,
    Customer = 2,
  }
  export enum NotificationMessageType {
    Reboot = 1,
    Logout = 2,
  }
  export enum CustomerType {
    Customer = 1,
    Guest = 2,
  }
  export enum DateType {
    Today = 0,
    CurrentMonth = 1,
    LastMonth = 2,
    Custom = 3,
    Yesterday = 4,
    CurrentWeek = 5,
    LastWeek = 6,
    CurrentYear = 7,
    LastYear = 8,
    Quarter1 = 9,
    Quarter2 = 10,
    Quarter3 = 11,
    Quarter4 = 12,
  }
  export enum MemberType {
    Member = 1,
    Guest = 2,
    Both = 3,
  }
  export enum CouponLimitType {
    NoLimit = 1,
    Global = 2,
    User = 3,
  }
  export enum DeliveryZoneType {
    Shape = 1,
    ZipCode = 2,
    Radius = 3,
  }
  export enum DeliveryShapeType {
    Circle = 1,
    Polygon = 2,
  }
  export enum MenuPricingType {
    Single = 1,
    Multiple = 2,
  }
  export enum FirebaseOrderType {
    DirectOrder = 1,
    KitchenHubOrder = 2,
    ShipdayOrder = 4,
  }
  export enum OrderStorageType {
    Recurring = 1,
    Firebase = 2,
    Blob = 3,
  }
  export enum ShipdayDeliveryStatusType {
    Active = 0,
    NotAssigned = 1,
    NotAccepted = 2,
    NotStartedYet = 3,
    Started = 4,
    PickedUp = 5,
    ReadyToDeliver = 6,
    AlreadyDelivered = 7,
    FailedDelivery = 8,
    InComplete = 9,
  }
}
